import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as ProviderServices from "../../../../services/ProviderService";
import { useTranslation } from "react-i18next";
import ProviderForm from "./providerForm.view";
import PATHS from "../../../../constants/paths";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

const ProviderFormContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});

  const setInitialValues = useCallback(async (data) => {
    const dataFinal = {   
      name: data.name,
    };
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    if (uuid) {
      const result = await ProviderServices.getProvider(uuid);
      if (result) {
        await setInitialValues(result);
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;

        if (uuid) {
          result = await ProviderServices.updateProvider(values, uuid);
        } else {
          result = await ProviderServices.addProvider(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.provider.messages.update.title");
            text = t("forms.provider.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.provider.messages.create.title");
            text = t("forms.provider.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.provider.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          navigate(PATHS.PROVIDER_LIST);
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleOnback = () => {
    navigate(PATHS.PROVIDER_LIST);
  };

  return (
    <ProviderForm
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onback={handleOnback}
    />
  );
};

ProviderFormContainer.propTypes = {
  t: PropTypes.any,
};

export default ProviderFormContainer;
